import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=6ca7869e&"
import script from "./resume.vue?vue&type=script&lang=ts&"
export * from "./resume.vue?vue&type=script&lang=ts&"
import style0 from "./resume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
